import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { compose } from 'redux';
import { questionActionTypes } from '../../../../../../../constants/questionActionTypes';
import { Person, FlashOn } from '@mui/icons-material';
import { Button, Card } from '@totalsoft/rocket-ui';

const OfferPartnerListQuestionActionsListComponent = ({ partnerQuestionActions, onRealBeneficiaryClick, t }) => {
  return (
    <Card title={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.Actions_Title')} icon={FlashOn}>
      <Grid>
        {partnerQuestionActions.some(x => x.questionActionTypeCode === questionActionTypes.REAL_BENEFICIARY) ? (
          <Button id={'offerPartnerQuestionnaire_RealBenBtn'} color='info' disabled={false} onClick={onRealBeneficiaryClick}>
            <Person /> {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.RealBeneficiary')}
          </Button>
        ) : (
          <> </>
        )}
      </Grid>
    </Card>
  );
};
OfferPartnerListQuestionActionsListComponent.propTypes = {
  partnerQuestionActions: PropTypes.array.isRequired,
  onRealBeneficiaryClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(OfferPartnerListQuestionActionsListComponent);
